/**
 * shared/suaDau.js — bỏ dấu chấm giữa "·" và gạch ngang dài "—" khỏi câu chữ.
 *
 * Quy tắc (cùng quy ước cho toàn site):
 *   - " · " giữa các mục → ", "
 *   - " — " chèn ý      → ", "
 *   - " — ý chèn — " (một cặp)  → ngoặc đơn
 *   - "Nhãn ngắn — …" ở đầu câu → "Nhãn ngắn: …"
 *   - " — " mà vế sau là một câu độc lập (bắt đầu bằng "nó", "đây", "điều đó",
 *     "hãy", "đừng"…) → tách thành câu mới, viết hoa chữ đầu.
 * Dấu đứng một mình (ô trống trong bảng) không đổi ở đây: chỗ đó cần chữ rõ
 * nghĩa như "chưa có", phải sửa tay.
 *
 * Dùng cho scripts/sua-dau-firestore.mjs. Kết quả là gợi ý máy làm: luôn xem
 * bản xem trước trước khi ghi.
 */
const MO_DAU_CAU = [
  'nó ', 'đây ', 'điều đó', 'điều ', 'chúng ', 'họ ', 'hãy ', 'đừng ', 'phụ lục', 'con số',
  'kết quả', 'bạn ', 'cách ', 'nhà đầu tư', 'quỹ ', 'người ', 'mọi ', 'không ai', 'khi đó',
];

const hoa = (s) => s.charAt(0).toLocaleUpperCase('vi') + s.slice(1);

export function suaDau(str) {
  if (typeof str !== 'string' || (!str.includes('—') && !str.includes('·'))) return str;
  // Cặp gạch bao một ý chèn ("… — ý chèn — …") → ngoặc đơn.
  let ra = str.replace(/ — ([^—.!?\n]{2,120}?) — /g, ' ($1) ');
  // Nhãn ngắn đứng đầu (tên nguồn, tên mục: "VnExpress — …") → dấu hai chấm.
  ra = ra.replace(/^([\p{Lu}\d][^\s—]*(?: [\p{Lu}\d][^\s—]*){0,2}) — /u, '$1: ');
  ra = ra.replace(/ — ([^\n]*)/g, (m, sau) => {
    const dau = sau.toLocaleLowerCase('vi');
    return MO_DAU_CAU.some((x) => dau.startsWith(x)) ? `. ${hoa(sau)}` : `, ${sau}`;
  });
  // Lặp lại vì một câu có thể có hai dấu, và regex trên đã ăn hết phần còn lại.
  for (let i = 0; i < 5 && ra.includes(' — '); i += 1) {
    ra = ra.replace(/ — ([^\n]*)/, (m, sau) => {
      const dau = sau.toLocaleLowerCase('vi');
      return MO_DAU_CAU.some((x) => dau.startsWith(x)) ? `. ${hoa(sau)}` : `, ${sau}`;
    });
  }
  return ra.replace(/ · /g, ', ');
}

export default suaDau;
